import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';

import { isOrNotConditionOptions } from 'constants/automation';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { useVenueList } from 'hooks/useVenueList';

const VenueFilter = ({ index, practiceAreaId = [], venueListOptions }) => {
  const { venueOptions, isVenueLoading } = useVenueList(false, practiceAreaId, { isCase: true, isLeads: false });
  const {
    formState: { errors },
    control,
    getValues,
    setValue,
  } = useFormContext();

  const [optionsVersion, setOptionsVersion] = useState(0);
  const [listVersion, setListVersion] = useState(0);
  const prevVenueListOptions = useRef(venueListOptions);
  const prevVenueOptions = useRef(venueOptions);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (venueListOptions !== prevVenueListOptions.current) {
      if (venueListOptions !== undefined && venueListOptions !== null && Array.isArray(venueListOptions)) {
        setOptionsVersion((prev) => prev + 1);
      }
      prevVenueListOptions.current = venueListOptions;
    }
  }, [venueListOptions]);

  useEffect(() => {
    if (venueOptions !== prevVenueOptions.current) {
      if (venueOptions !== undefined && venueOptions !== null && Array.isArray(venueOptions)) {
        setListVersion((prev) => prev + 1);
      }
      prevVenueOptions.current = venueOptions;
    }
  }, [venueOptions]);

  const options = useMemo(() => {
    const optionsHasUpdates = optionsVersion > 0;
    const listHasUpdates = listVersion > 0;

    if (optionsHasUpdates && listHasUpdates) {
      return optionsVersion >= listVersion ? venueListOptions || [] : venueOptions || [];
    } else if (optionsHasUpdates) {
      return venueListOptions || [];
    } else if (listHasUpdates) {
      return venueOptions || [];
    }
    return venueOptions || [];
  }, [venueListOptions, venueOptions, optionsVersion, listVersion]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const currentValue = getValues(`filters.${index}.value`);
    const selectedValue = currentValue?.['case_description.venue'];

    if (selectedValue && options.length > 0) {
      const validOptionIds = options?.map((option) => option?.venue_id);
      if (!validOptionIds.includes(selectedValue)) {
        setValue(`filters.${index}.value`, { 'case_description.venue': [] }, { shouldValidate: true });
      }
    }
    if (options.length === 0) {
      setValue(`filters.${index}.value`, { 'case_description.venue': [] }, { shouldValidate: true });
    }
  }, [options, index, getValues, setValue]);

  return (
    <>
      <div className="me-2 filterbar-condition">
        <Controller
          name={`filters.${index}.condition`}
          control={control}
          rules={{ required: 'Condition is required' }}
          render={({ field }) => (
            <Dropdown
              options={isOrNotConditionOptions}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              placeholder="Select Condition"
              className="w-100"
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.condition`} errors={errors} />
      </div>
      <div className="me-2 filterbar-value">
        <Controller
          name={`filters.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <Dropdown
              options={options}
              value={field.value?.['case_description.venue'] || ''}
              name={field.name}
              onChange={(e) => field.onChange({ 'case_description.venue': e.value })}
              filter
              className="input-shadow w-100"
              display="chip"
              placeholder="Select"
              optionLabel="venue_name"
              optionValue="venue_id"
              dropdownIcon={isVenueLoading ? 'pi pi-spin pi-spinner' : undefined}
              inputRef={field.ref}
            />
          )}
        />
        <RequiredValidation field={`filters.${index}.value`} errors={errors} />
      </div>
    </>
  );
};

export default VenueFilter;
